import { useTranslation } from "react-i18next";
import { GoBack } from "../../components/ui/goBack";
import { Meta } from "../../meta/meta";
import { useLocation } from "react-router-dom";
import styles from "../template/models/styles.module.scss";

const Policy = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  const title = pathname?.includes("/personal")
    ? "personal_title"
    : "availability_title";
  const description = pathname?.includes("/personal")
    ? "personal_text"
    : "availability_text";

  return (
    <>
      <Meta title={title} description={description} />

      <main className={styles.modelThree}>
        <div className="container">
          <div className={styles.modelThree_context}>
            <GoBack />

            <div className={styles.modelThree_main}>
              <div
                className={styles.modelThree_main_column}
                style={{ width: "100%" }}
              >
                <h1>{`${t(title)}`}</h1>

                <div
                  className={styles.modelThree_main_column_text}
                  dangerouslySetInnerHTML={{
                    __html: t(description),
                  }}
                ></div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default Policy;
